import Dashboard from "./Dashboard.vue";

// Landing screen
import ProviderRoutes from "@/module/provider/routes";
import EngagementRoutes from "@/module/engagement/routes";
import ResponseRoutes from "@/module/response/routes";
import AddRoutes from "@/module/add/route";
import PopulationRoutes from "@/module/population/routes";
import FilterRoutes from "@/module/filter/routes";
import ReachoutRoutes from "@/module/reachout/routes";
import UpcomingRoutes from "@/module/upcoming/routes";
import TagRoutes from "@/module/tag/routes";
import OutcomeRoutes from "@/module/outcome/routes";
import OverviewRoutes from "@/module/overview/routes";

import MeetingRoutes from "@/module/meeting/routes";

// Settings
import SettingsRoutes from "@/module/settings/route";

export default [
  {
    path: "",
    redirect: "patient",
  },
  {
    path: "/",
    component: Dashboard,
    redirect: "patient",

    children: [
      ...ProviderRoutes,
      ...EngagementRoutes,
      ...ResponseRoutes,
      ...AddRoutes,
      ...PopulationRoutes,
      ...FilterRoutes,
      ...ReachoutRoutes,
      ...UpcomingRoutes,
      ...SettingsRoutes,
      ...OutcomeRoutes,
      ...TagRoutes,
      ...OverviewRoutes,
    ],
  },
  ...MeetingRoutes,
];
